<app-confirmation-dialog [props]="props">
  <div id="reg-data-modal-content" class="body-container">
    <div id="reg-data-modal-lbl-doc" class="registration-data-modal-subtitle">
      <span i18n="@@registrationDataModalDocLabel">Documento:</span>
      {{ formattedRegistryDocument }}
    </div>

    <app-generic-table
      [id]="'reg-data-modal-table'"
      [style]="{ 'min-height': '150px' }"
      [isLoading]="isLoading()"
      [config]="tableConfig"
      [data]="rows()"
      [showPagination]="false"
    >
      <ng-template appTableCell="label" let-row>
        <app-truncated-text [text]="row.label || '-'" [maxLines]="2" />
      </ng-template>

      <ng-template appTableCell="value" let-row>
        <app-truncated-text [text]="row.value || '-'" [maxLines]="2" />
      </ng-template>
    </app-generic-table>
  </div>
</app-confirmation-dialog>
